import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import { earningsHeadlineLevels } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/constants'

import { earningsBridgeColumnOrder, earningsBridgeCopies, earningsBridgePlotHeight } from '../constants'
import * as Styles from './styles'

const NetSalesToMarginCardSkeleton = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('De ventas netas a margen')}</CardTitle>
      <CardDescription>{t(earningsBridgeCopies[earningsHeadlineLevels.operating].subtitle)}</CardDescription>
      <Styles.Body>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Styles.Columns>
          {earningsBridgeColumnOrder.map(key => (
            <Skeleton key={key} variant="rectangular" width="100%" height={earningsBridgePlotHeight} />
          ))}
        </Styles.Columns>
        <Skeleton variant="text" width={420} height={16} />
      </Styles.Body>
    </Card>
  )
}

export default NetSalesToMarginCardSkeleton
